// extracted by mini-css-extract-plugin
export default {"resultHolder":"mayatool_resultHolder__DcZ6N","resultHeading":"mayatool_resultHeading__wSnEE","btn":"mayatool_btn__rD+kC","btnGrey":"mayatool_btnGrey__R7rQO"};